if (!customElements.get('swiper-slider')) {
  customElements.define('swiper-slider', class SwiperSlider extends BaseElement
  {
    init()
    {
      let json = {};

      try {
        if (this.dataset.swiper) {
          json = JSON.parse(this.dataset.swiper);
        }
      } catch (e) {
        console.error('Invalid JSON in swiper config for', this, this.dataset.swiper, e.message);

        return;
      }

      this.container = this.querySelector('.swiper');
      this.config = json;

      const arrowNext = this.querySelector('.swiper-button-next');
      const arrowPrev = this.querySelector('.swiper-button-prev');

      if (arrowNext && arrowPrev && (typeof(this.config.navigation) === 'undefined' || typeof(this.config.navigation.nextEl) === 'undefined')) {
        this.config.navigation = {
          nextEl: arrowNext,
          prevEl: arrowPrev,
          ...this.config.navigation || {}
        };
      }

      const pagination = this.querySelector('.swiper-pagination');

      if (pagination && (typeof(this.config.pagination) === 'undefined' || typeof(this.config.pagination.el) === 'undefined')) {
        this.config.pagination = {
          el: pagination,
          ...this.config.pagination || {}
        };
      }

      console.log('Initializing swiper', this.container, this.config);

      this.reinit();

      window.addEventListener('resize', () => {
        this.reinit();
      });
    }

    reinit()
    {
      let enabled = true;

      if (typeof(this.config.enabled) !== 'undefined') {
        enabled = this.config.enabled;
      }

      if (this.config.breakpoints) {
        Object.keys(this.config.breakpoints).forEach(breakpoint => {
          let isCurrentBreakpoint = matchMedia(`(min-width: ${parseInt(breakpoint)}px)`).matches;

          if (isCurrentBreakpoint
            && typeof(this.config.breakpoints[breakpoint]) !== 'undefined'
            && typeof(this.config.breakpoints[breakpoint].enabled) !== 'undefined'
          ) {
            enabled = this.config.breakpoints[breakpoint].enabled;
          }
        });
      }

      // Enable/disable swiper based on breakpoints

      if (!this.swiper && enabled) {
        this.swiper = new Swiper(this.container, this.config);
      } else if (this.swiper && !enabled) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  });
}